<li class="{{className}}" [ngClass]="{'active':isActive}" (click)="clickEvent()" *ngIf="!isLink">
  <span  class="bt-icon"><itb-icon [tooltipText]="''" [className]="iconClassName"></itb-icon></span>
  <span class="bt-txt"><itb-text [className]="'text-small'" [text]="text"></itb-text></span>
  <span *ngIf="hasEditButton" class="bt-edit"><itb-icon [tooltipText]="" [className]="'edit icon-disabled'" (click)="editEvent()"></itb-icon></span>
  <span *ngIf="hasCloseButton" class="bt-cross"><itb-icon [tooltipText]="'Close'" [className]="'cross icon-disabled'" (click)="closeEvent()"></itb-icon></span>
</li>


<a *ngIf="isLink" [routerLink]="link">
<li class="{{className}}" [ngClass]="{'active':isActive}"  routerLinkActive="active"  (click)="clickEvent()">
    <span  class="bt-icon"><itb-icon [tooltipText]="''" [className]="iconClassName"></itb-icon></span>
    <span class="bt-txt"><itb-text [className]="'text-small'" [text]="text"></itb-text></span>
    <span *ngIf="hasEditButton" class="bt-edit"><itb-icon [tooltipText]="" [className]="'edit icon-disabled'" (click)="editEvent()"></itb-icon></span>
    <span *ngIf="hasCloseButton" class="bt-cross"><itb-icon [tooltipText]="'Close'" [className]="'cross icon-disabled'" (click)="closeEvent()"></itb-icon></span>
</li>
</a>
